import { useLocation, useMatches } from '@tanstack/react-router';

// The search an anonymous visitor's Sign in / Join CTA carries: the page
// they're on as `next`, so they land back on it once signed in — or, for a
// new member, once onboarding finishes. Empty on the Join landing itself
// (/, /sign-in, /get-started): those aren't destinations of their own, and
// the landing layout's retain middleware already carries any `next` the
// visitor arrived with.
export function useReturnHereSearch(): { readonly next?: string } {
  const href = useLocation({ select: (location) => location.href });
  const onJoinLanding = useMatches({
    select: (matches) => matches.some((match) => match.routeId === '/_public/_landing'),
  });
  return onJoinLanding ? {} : { next: href };
}
